$(() => {
  // ツールチップの表示
  $('[data-toggle="tooltip"]').tooltip();
});
